<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <router-link to="/pedido"> Suprimentos/Pedido de Compra </router-link>
      <label class="labelBar"> / </label>
      <label> Inativar</label>
    </div>
    <v-container fluid>
      <v-form>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="8">
            <h2 class="display-1 font-weight-bold mb-4">Pedido de Compra</h2>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="pedido.id"
              hide-details
              label="Pedido nº"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="idorigem"
              hide-details
              :label="origem"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-list-subheader>Dados de Faturamento</v-list-subheader>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="faturamento"
              hide-details
              solo
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="cnpj"
              label="CNPJ"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="inscricao"
              hide-details
              label="Inscrição Estadual"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-list-subheader></v-list-subheader>
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model="endereco"
              label="Endereço"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="telefone"
              label="Telefone"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="2">
            <v-list-subheader>Endereço de Entrega</v-list-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field
              v-model="pedido.enderecoLocal"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row>
          <v-col cols="2">
            <v-list-subheader>Dados do Fornecedor</v-list-subheader>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="pedido.fornecedor"
              hide-details
              solo
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="pedido.cnpjFornecedor"
              hide-details
              label="CNPJ"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="pedido.ieFornecedor"
              hide-details
              label="Inscrição Estadual"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-list-subheader></v-list-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field
              v-model="pedido.enderecoFornecedor"
              hide-details
              label="Endereço"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2">
            <v-list-subheader></v-list-subheader>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="pedido.contatoFornecedor"
              hide-details
              label="Contato"
              single-line
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="pedido.telefoneFornecedor"
              hide-details
              label="telefone"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="pedido.emailFornecedor"
              hide-details
              label="Email"
              single-line
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-form>

      <v-card>
        <v-data-table :headers="headers" hide-default-footer :items-per-page="-1" :items="pedido.produtos">
        </v-data-table>
      </v-card>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="3">
          <v-list-subheader>Pedido Gerado Pelo Comprador: </v-list-subheader>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="formatocomprador"
            hide-details
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider class="my-4"></v-divider>
      <div>
        <label
          ><h2>Deseja realmente inativar o pedido N°{{ pedido.id }}?</h2></label
        >
      </div>
      <v-alert v-if="!pedidoPodeSerInativado()" type="warning" dense outlined>
        {{ mensagemBloqueioInativacao() }}
      </v-alert>
      <div class="my-4"></div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <label>Justifique o motivo da inativação:</label>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-textarea
              outlined
              v-model="justificativa"
              clear-icon="mdi-close-circle"
              label="Justificativa"
              prepend-icon="mdi-comment"
              maxlength="200"
              counter
              :rules="[(v) => (!!v && !!v.trim()) || 'A Justificativa é obrigatória']"
              required
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/pedido" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn
            @click="inativar()"
            :disabled="!pedidoPodeSerInativado()"
            color="success"
            class="mr-4"
          >
            Inativar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
</div>
</template>


<script>
import { inativarPedidoAsync } from "../../../services/pedidoService";
import { mapState, mapActions } from "vuex";
import { canApproveModule, getUserRoles } from "@/services/loginService";

export default {
  name: "inativarPedido",
  data: () => ({
    overlay: false,
    valid: true,
    readOnly: false,
    faturamento: "SALUM CONSTRUÇÕES LTDA",
    cnpj: "19.739.564/0001-79",
    inscricao: "062.566.556.0021",
    endereco:
      "RUA DOS TIMBIRAS, 559 - Bairro Funcionários - Belo Horizonte / MG - CEP:30.140-060",
    telefone: "(31) 3271 2151",
    formatocomprador: null,
    justificativa: null,
    headers: [
      { text: "SC", value: "idSolicitacao", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Local", value: "localEntrega", sortable: false },
      { text: "Qnt", value: "idProduto", sortable: false },
      { text: "Item", value: "quantidade", sortable: false },
      { text: "Codigo", value: "codigo", sortable: false },
      { text: "Un", value: "unidadeMedida", sortable: false },
      { text: "Vr.Unit.", value: "valorUnitario", sortable: false },
      { text: "Desc.", value: "descontoProduto", sortable: false },
      { text: "Total c/ Desc.", value: "total", sortable: false },
      { text: "Prazo", value: "prazoEntrega", sortable: false },
    ],
  }),
  computed: {
    ...mapState("pedido", ["pedido"]),
  },
  methods: {
    ...mapActions("pedido", ["updatePedido"]),
    ...mapActions("mapaCotacao", ["atualizarProdutosPreSelecionadosNovoMapa"]),
    pedidoPodeSerInativado() {
      return !["RP", "IR", "I"].includes(this.pedido.status);
    },
    mensagemBloqueioInativacao() {
      if (this.pedido.status === "RP") {
        return "Não é possível inativar este Pedido de Compra, pois ele possui recebimento parcial.";
      }
      if (this.pedido.status === "IR") {
        return "Não é possível inativar este Pedido de Compra, pois seus itens já foram recebidos.";
      }
      if (this.pedido.status === "I") {
        return "Este Pedido de Compra já está inativo.";
      }
      return "";
    },
    async inativar() {
      if (!this.pedidoPodeSerInativado()) {
        this.$alert(this.mensagemBloqueioInativacao(), "Operação não permitida", "warning");
        return;
      }
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await inativarPedidoAsync(this.pedido.id, this.justificativa);

        if (resposta == null || resposta.status != 200) {
          this.overlay = false;
          this.$alert(resposta?.message || "Nao foi possivel inativar o pedido.", "Desculpe, falha na operacao!", "error");
        } else {
          this.overlay = false;
          const pedidoInativado = resposta.data || this.pedido;
          const produtosNovoMapa = pedidoInativado.produtosNovoMapa || [];
          this.pedido.status = "I";
          this.pedido.ativo = false;
          this.updatePedido({ ...this.pedido, ...pedidoInativado, status: "I", ativo: false });
          this.$store.dispatch("ui/showSnackbar", {
            text: "Pedido inativado!",
            color: "success",
            timeout: 3000,
          });

          if (this.pedido.idMapaCotacao && this.pedido.idMapaCotacao > 0 && produtosNovoMapa.length > 0) {
            try {
              await this.$confirm(
                "Deseja gerar um novo Mapa de Cotação com os itens e quantidades deste Pedido de Compra?",
                "Novo Mapa de Cotação",
                {
                  confirmButtonText: "SIM",
                  cancelButtonText: "NÃO",
                  type: "question",
                }
              );
              this.atualizarProdutosPreSelecionadosNovoMapa(produtosNovoMapa);
              this.$router.push({ path: "/mapaCotacao/criar", query: { pedidoInativado: this.pedido.id } });
              return;
            } catch (e) {
              this.atualizarProdutosPreSelecionadosNovoMapa([]);
            }
          }

          this.$router.push("/pedido");
        }
      }
    },
    isApproving(id) {
      return canApproveModule(id);
    },

  },
  created: function () {
    this.readOnly = true;
    const data = new Date(this.pedido.dataCriacao);
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();

    const horas = String(data.getHours()).padStart(2, "0");
    const minutos = String(data.getMinutes()).padStart(2, "0");
    const segundos = String(data.getSeconds()).padStart(2, "0");
    this.formatocomprador =
      this.pedido.comprador +
      " as " +
      horas +
      ":" +
      minutos +
      ":" +
      segundos +
      " do dia " +
      dia +
      "/" +
      mes +
      "/" +
      ano;
    this.origem =
      this.pedido.idMapaCotacao != null && this.pedido.idMapaCotacao > 0
        ? "Mapa"
        : "Requisicao";
    this.idorigem =
      this.pedido.idMapaCotacao != null && this.pedido.idMapaCotacao > 0
        ? this.pedido.idMapaCotacao
        : this.pedido.idRequisicao;

    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  }
};
</script>
